import React from 'react';

import HalalboxPrime from '../../../feature/halalbox-prime/HalalboxPrime';
import Modal from 'components/mweb/Modal/Modal';

const HBPrimeModal = ({ visible = false, onCancel = () => {} }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered={true}
      destroyOnClose={true}
      closable={false}
      wrapClassName="bottom-sheet-hb-prime"
      zIndex={900}
    >
      <HalalboxPrime source="CART" onCancel={onCancel} />
    </Modal>
  );
};

export default HBPrimeModal;
